import { BaggageType, GdsServiceVipSubType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
export function getRelatedServiceType(type, subType) {
    switch (type) {
        case OrderAdditionalServiceGdsServiceServiceType.Seat:
            return 'Seat';
        case OrderAdditionalServiceGdsServiceServiceType.Baggage:
            switch (subType) {
                case BaggageType.PetInCabin:
                case BaggageType.PetInHandCarrier:
                case BaggageType.PetInHold:
                    return 'Animal';
                default:
                    return 'Baggage';
            }
        case OrderAdditionalServiceGdsServiceServiceType.Meal:
            return 'Meal';
        case OrderAdditionalServiceGdsServiceServiceType.BusinessLounge:
            return 'BusinessLounge';
        case OrderAdditionalServiceGdsServiceServiceType.Vip:
            switch (subType) {
                case GdsServiceVipSubType.BaggageDelivery:
                    return 'BaggageDelivery';
                case GdsServiceVipSubType.BusinessLounge:
                case GdsServiceVipSubType.BusinessLoungeInternational:
                    return 'BusinessLounge';
                case GdsServiceVipSubType.PriorityBoarding:
                    return 'PriorityBoarding';
                case GdsServiceVipSubType.CapsuleHotel:
                    return 'CapsuleHotel';
                case GdsServiceVipSubType.GroundTransportation:
                    return 'Transfer';
                case GdsServiceVipSubType.Upgrade:
                    return 'Upgrade';
                case GdsServiceVipSubType.SMS:
                    return 'Sms';
                case GdsServiceVipSubType.UnknownSubtype:
                    return null;
                default:
                    return null;
            }
        case OrderAdditionalServiceGdsServiceServiceType.Misc:
            return null;
    }
}
